
import './style.css'
// import * as dat from 'lil-gui'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
// import {FirstPersonControls} from 'three/examples/jsm/controls/FirstPersonControls.js'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js'
import TWEEN from 'tween/tween.js'
// import * as Stats from 'stats.js'
// import WebGPURenderer from 'three/examples/jsm/renderers/webgpu/WebGPURenderer.js'

/**
 * Base
 */
// Debug
// const debugObject = {}
// const gui = new dat.GUI({
//     width: 200
// })

// stats
// const stats = new Stats()
// document.body.appendChild(stats.dom)


// Canvas
const canvas = document.querySelector('canvas.webgpu')

// Scene
const scene = new THREE.Scene()


/**
 * Loaders
 */
//LOADER

const loadingManager = new THREE.LoadingManager(
    //loaded
    () =>
    {
        console.log('loaded');
    },
    //progress
    () =>
    {
        console.log('progress');
    },
    //error
    () =>
    {
        console.log('error');
    }
)
    // 监听网页加载完成事件
    window.addEventListener("load", function() {
      // 延迟2秒后执行加载操作
      setTimeout(function() {
        // 获取蒙版元素
        const mask = document.getElementById("mask");  
        const selector = document.getElementById("selector");
        // 隐藏蒙版元素
        mask.style.display = "none";
        mask.style.zIndex = 0; 
        // 显示网页内容元素
        canvas.style.display = "block";
        // 显示选择器元素 

        selector.style.display = "block";
        setTimeout(function() {
        selector.style.opacity = 1;
        }, 100);
        selector.style.zIndex = 2;
      }, 2000);

    });
/**
 * fog
 */
const fog = new THREE.FogExp2('#333333', 0.02)
scene.fog = fog

// gui.addColor(debugObject,'fogColor').onChange(() =>
// {
//     fog.color.set(debugObject.fogColor)
// })


// Texture loader
const textureLoader = new THREE.TextureLoader(loadingManager)

// Draco loader
const dracoLoader = new DRACOLoader(loadingManager)
dracoLoader.setDecoderPath('/draco/')
dracoLoader.setDecoderConfig({ type: 'js' })


// GLTF loader
const gltfLoader = new GLTFLoader(loadingManager)
gltfLoader.setDRACOLoader(dracoLoader)

/**
 * Textures
 */
const bakedTexture = textureLoader.load('downtobaked.jpg')
bakedTexture.flipY = false
bakedTexture.colorSpace = THREE.SRGBColorSpace


/**
 * Materials
 */
// Baked material
const bakedMaterial = new THREE.MeshBasicMaterial({ map: bakedTexture }) 





/**
 * Model
 */
gltfLoader.load(
    'downto.glb',
    (gltf) =>
    {
        scene.add(gltf.scene)
         //将纹理贴图应用到模型上
        gltf.scene.traverse((child) =>
        {
            child.material = bakedMaterial
        })

       
        
    }
)

/**
 * Sizes
 */
const sizes = {
  width: window.innerWidth,
  height: window.innerHeight
}

window.addEventListener('resize', () =>
{
  // Update sizes
  sizes.width = window.innerWidth
  sizes.height = window.innerHeight

  // Update camera
  camera.aspect = sizes.width / sizes.height
  camera.updateProjectionMatrix()


  // Update renderer
  renderer.setSize(sizes.width, sizes.height)
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

  
})





/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(45, sizes.width / sizes.height, 0.1, 1000)
camera.position.set(100, 100, 0)
camera.lookAt(new THREE.Vector3(14, 0, 0))


//用tweenjs将相机从（100，100，0）移动到（50，6，0）
  // 监听网页加载完成事件
window.addEventListener("load", function() {
  new TWEEN.Tween(camera.position)
      .to({ x: 45, y: 8, z: 0 }, 3000)
      .easing(TWEEN.Easing.Cubic.Out)
      .start()
      scene.add(camera)
})
// 跟踪按下的次数
let spaceKeyPressCount = 0;

// 监听空格键
window.addEventListener("keyup", function(e) {
  if (e.code === "Space") {
    spaceKeyPressCount++; // 增加按下次数

    // 根据按下次数设置相机位置
    if (spaceKeyPressCount % 2 === 1) {
      // 奇数次按下，将相机位置设置为（14，20，0）
      new TWEEN.Tween(camera.position)
        .to({ x: 14, y: 27, z: 0 }, 3000)
        .easing(TWEEN.Easing.Cubic.Out)
        .start();
    } else {
      // 偶数次按下，将相机位置设置为（45，8，0）
      new TWEEN.Tween(camera.position)
        .to({ x: 45, y: 8, z: 0 }, 3000)
        .easing(TWEEN.Easing.Cubic.Out)
        .start();
    }
  }
});

//监听手机双击事件
let lastTouchEnd = 0;
window.addEventListener('touchend', function (event) {
    const now = (new Date()).getTime();
    if (now - lastTouchEnd <= 300) {
        spaceKeyPressCount++; // 增加按下次数

        // 根据按下次数设置相机位置
        if (spaceKeyPressCount % 2 === 1) {
            // 奇数次按下，将相机位置设置为（14，20，0）
            new TWEEN.Tween(camera.position)
                .to({ x: 14, y: 27, z: 0 }, 3000)
                .easing(TWEEN.Easing.Cubic.Out)
                .start();
        } else {
            // 偶数次按下，将相机位置设置为（45，8，0）
            new TWEEN.Tween(camera.position)
                .to({ x: 45, y: 8, z: 0 }, 3000)
                .easing(TWEEN.Easing.Cubic.Out)
                .start();
        }
    }
    lastTouchEnd = now;
}, false);





//FirstPersonControls
// const controls = new FirstPersonControls(camera, canvas)

    
  
    
// OrbitControls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true
controls.enablePan = false
controls.target.set(13.8  , 0, 0)
controls.minDistance = 3
controls.maxDistance = 100
controls.minPolarAngle = 0
controls.maxPolarAngle = Math.PI * 0.45


/**
 * pool
 */
// // threeaudio
// const listener = new THREE.AudioListener();
// camera.add( listener );

// // 创建一个全局 audio 源
// const sound = new THREE.Audio( listener );

// // 加载一个 sound 并将其设置为 Audio 对象的缓冲区
// const audioLoader = new THREE.AudioLoader();
// audioLoader.load( 'IMPACT1.mp3', function( buffer ) {
// 	sound.setBuffer( buffer );
// 	sound.setLoop( true );
// 	sound.setVolume( 0.5 );
// 	// sound.play();
// });

// //webaudio
// // 创建音频上下文和分析器
// var audioContext = new AudioContext();
// var analyser = audioContext.createAnalyser();
// var dataArray = new Uint8Array(analyser.frequencyBinCount);

// if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
//   // 使用 getUserMedia
// } else {
//   console.error('浏览器不支持 getUserMedia');
// }


// navigator.mediaDevices.getUserMedia({ audio: true })
//   .then(function(stream) {
//     // 处理音频流
//     var audioInput = audioContext.createMediaStreamSource(stream);
//         audioInput.connect(analyser);
//         // analyser.connect(audioContext.destination); 
//         updateSmoothedDataArray();
//   })
//   .catch(function(err) {
//     // 处理错误
//     console.error('获取麦克风输入时出错：', err);
//     alert('无法获取麦克风输入,请检查麦克风权限');
//   });



// // 创建一个新的数组来存储平滑后的频率数据
// let smoothedDataArray = new Uint8Array(analyser.frequencyBinCount);

// // 设置权重因子
// const smoothingFactor = 0.7;

function updateSmoothedDataArray() {
  // 获取新的频率数据
  analyser.getByteFrequencyData(dataArray);
  
  // 打印出第一个和最后一个频率的数据，以便确认我们是否正在接收到音频数据
  // console.log('First frequency data: ', dataArray[0]);
  // console.log('Last frequency data: ', dataArray[dataArray.length - 1]);

  // 对每个频率进行平滑处理
  for (let i = 0; i < dataArray.length; i++) {
      smoothedDataArray[i] = smoothingFactor * smoothedDataArray[i] + (1 - smoothingFactor) * dataArray[i];
  }
}


 
// 你的three.js相关代码
const listener = new THREE.AudioListener();
camera.add(listener);

// 创建一个全局 audio 源
const sound = new THREE.Audio(listener);

// 加载一个 sound 并将其设置为 Audio 对象的缓冲区
// const audioLoader = new THREE.AudioLoader();
// audioLoader.load('IMPACT1.mp3', function(buffer) {
//   sound.setBuffer(buffer);
//   sound.setLoop(true);
//   sound.setVolume(0.5);
//   sound.play();
// });

// Web Audio相关代码
// 创建 AudioContext 变量并初始化
let audioContext = new AudioContext();

const analyser = audioContext.createAnalyser();
let dataArray = new Uint8Array(analyser.frequencyBinCount);
let smoothedDataArray = new Uint8Array(analyser.frequencyBinCount);
const smoothingFactor = 0.7;
let audioInput;

// const audioElement = new Audio();
// audioElement.src = 'IMPACT1.mp3';

document.getElementById('IMPACT').addEventListener('click', function() {
  if(audioInput) audioInput.disconnect();
  // 检查 AudioContext 是否已创建
  if (!audioContext) {
    // 创建 AudioContext
    audioContext = new AudioContext();
  } else if (audioContext.state === 'suspended') {
    // 如果 AudioContext 处于暂停状态，则恢复它
    audioContext.resume();
  }
  const audioElement = new Audio();
  audioElement.src = 'IMPACT1.mp3';
  audioElement.play()
  .catch(function(error) {
    console.error('播放音频时出错：', error);
  });;
  audioInput = audioContext.createMediaElementSource(audioElement);
  audioInput.connect(analyser);
  audioInput.connect(audioContext.destination); // 将音频源连接到音频上下文的目标，以便播放音频
},false);

document.getElementById('LIVE').addEventListener('click', function() {
  if(navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
    navigator.mediaDevices.getUserMedia({ audio: true })
      .then(function(stream) {
        if(audioInput) audioInput.disconnect();
        audioInput = audioContext.createMediaStreamSource(stream);
        audioInput.connect(analyser);
        updateSmoothedDataArray();
        
      })
      .catch(function(err) {
        console.error('获取麦克风输入时出错：', err);
        alert('无法获取麦克风输入,请检查麦克风权限');
      });
  } else {
    console.error('浏览器不支持 getUserMedia');
  }
});





// Geometry
const poolGeometry = new THREE.PlaneGeometry()

// Material
const poolMaterial = new THREE.MeshPhongMaterial({ color: '#ffffff' })

// pool
const pool = new THREE.Mesh(poolGeometry, poolMaterial)
pool.position.set(14, -1, 0)
pool.rotateY(Math.PI * 0.5)
pool.rotateX(- Math.PI * 0.5)
pool.scale.set(25, 18, 50)
pool.receiveShadow = true;
scene.add(pool)


//boxes
const colorAndCounts = [
  { color: '#000000', count: 15 }, // 黑色, 10个
  { color: '#202020', count: 10 }, // 灰色, 15个
  { color: '#ffffff', count: 15 }  // 白色, 20个
];const boxes = [];
const boxxzsize = 3;
const minDistance = 2; // 这是箱子之间的最小距离

colorAndCounts.forEach(item => {
  for(let i = 0; i < item.count; i++) {
    const boxGeometry = new THREE.BoxGeometry(Math.random() * boxxzsize + 0.5, Math.random(), Math.random() * boxxzsize + 0.5);
    const boxMaterial = new THREE.MeshPhongMaterial({ color: item.color });
    const box = new THREE.Mesh(boxGeometry, boxMaterial);
    
    // 游泳池在X轴和Z轴上的范围
    const poolRangeX = pool.scale.x / 2 * 0.9;
    const poolRangeZ = pool.scale.z / 2 * 0.8;

    // 随机生成箱子在游泳池平面内的位置
    let positionValid = false;
    while(!positionValid) {
      // 随机生成箱子在游泳池平面内的位置
      box.position.x = (pool.position.x - 1) + (Math.random() - 0.5) * poolRangeX;
      box.position.z = pool.position.z  + (Math.random() - 0.5) * poolRangeZ;

      positionValid = true;
      for(let j = 0; j < boxes.length; j++) {
        const otherBox = boxes[j];
        const dx = otherBox.position.x - box.position.x;
        const dz = otherBox.position.z - box.position.z;
        const distance = Math.sqrt(dx * dx + dz * dz);

        if(distance < minDistance) {
          positionValid = false;
          break;
        }
      }
    }
    // 设置频率索引
    let frequencyRangeStart;
    let frequencyRangeEnd;
    
    if (item.color === '#000000') {
      // 黑色箱子，使用低频数据
      frequencyRangeStart = 0;
      frequencyRangeEnd = dataArray.length / 3;
    } else if (item.color === '#202020') {
      // 灰色箱子，使用中频数据
      frequencyRangeStart = dataArray.length / 3;
      frequencyRangeEnd = dataArray.length * 2 / 3;
    } else if (item.color === '#ffffff') {
      // 白色箱子，使用高频数据
      frequencyRangeStart = dataArray.length * 2 / 3;
      frequencyRangeEnd = dataArray.length - 1;
    }

    box.userData.frequencyIndex = Math.floor(Math.random() * (frequencyRangeEnd - frequencyRangeStart) + frequencyRangeStart);

    // 箱子的y位置设置为游泳池的y位置 + 箱子的一半高度，这样箱子就会在游泳池平面内
    box.position.y = pool.position.y 
    

    box.userData.randomValue = Math.random() ;
    box.receiveShadow = true;
    box.castShadow = true;
    scene.add(box);
    boxes.push(box);

}
});

//Light

const ambientLight = new THREE.AmbientLight(0xffffff, 0.5);
scene.add(ambientLight);

const light = new THREE.DirectionalLight(0xffffff, 0.5);
light.position.set(20, 5, 8);
light.scale.set(1, 1, 1);
light.target = pool;
scene.add(light);
// 设置光源产生阴影
light.castShadow = true;
light.shadow.mapSize.width = 2048;
light.shadow.mapSize.height = 2048;
light.shadow.camera.near = 1;
light.shadow.camera.far = 30;
light.shadow.camera.top = 10;
light.shadow.camera.bottom = -7;
light.shadow.camera.left = -15;
light.shadow.camera.right = 15;
// helper
const lightHelper = new THREE.CameraHelper(light.shadow.camera);
// scene.add(lightHelper);


/** 
 * underground
 * */ 
const undergroundGeometry = new THREE.PlaneGeometry()
const undergroundMaterial = new THREE.MeshBasicMaterial({ color: '#000000' })
const underground = new THREE.Mesh(undergroundGeometry, undergroundMaterial)
underground.position.set(-4, -0.75, -0.8)
underground.rotateY(Math.PI * 0.5)
underground.scale.set(5,1.47,5)

const underground1Geometry = new THREE.PlaneGeometry()
const underground1 = new THREE.Mesh(underground1Geometry, undergroundMaterial)
underground1.position.set(-0, -0.75, -0.8)
underground1.rotateY(Math.PI * - 0.5)
underground1.scale.set(5,1.47,5)

const underground2Geometry = new THREE.PlaneGeometry()
const underground2 = new THREE.Mesh(underground2Geometry, undergroundMaterial)
underground2.position.set(-2, -0.75, -3)
underground2.rotateY(0)
underground2.scale.set(5,1.47,5)


scene.add(underground,underground1,underground2)








/**
 * Renderer设置
 */

// 原始
// 设置两个渲染器，一个是threejs的渲染器，一个是webgpu的渲染器，然后添加到同一个canvas上并添加到gui上

// const renderer = new WebGPURenderer({
//     canvas: canvas,
//     antialias: true})

const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    antialias: true})
renderer.shadowMap.enabled = true;
renderer.outputColorSpace = 'srgb'
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
renderer.setClearColor('#333333')

/**
 * Animate
 */
const clock = new THREE.Clock()

const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()

    //statsbegin
    
    // stats.begin()

    

    //update tween
    TWEEN.update()
    
    //箱子跳动
    analyser.getByteFrequencyData(dataArray)

    updateSmoothedDataArray();
    
    
    // // 根据音频数据更新箱子的位置和高度
    boxes.forEach(box => {
      const frequencyIndex = box.userData.frequencyIndex;
      if (frequencyIndex !== undefined && frequencyIndex < smoothedDataArray.length) {
        const frequencyData = smoothedDataArray[frequencyIndex];
        
        // 打印出来以便调试
        // console.log('Frequency data: ', frequencyData);
      
        if (box.material.color.getHexString() === '000000') {
            // 黑色箱子
            box.scale.y = frequencyData / 128 * 4 + 0.12 + box.userData.randomValue ;
        } else if (box.material.color.getHexString() === '202020') {
            // 灰色箱子
            box.scale.y = frequencyData / 128 * 4 + 0.1 + box.userData.randomValue;
        } else if (box.material.color.getHexString() === 'ffffff') {
            // 白色箱子
            box.scale.y = frequencyData / 128 * 4 + 0.09 + box.userData.randomValue ;
        } else {
          console.error('Invalid frequency index: ', frequencyIndex);
        }
    }
    });

      

    

      

    // Update controls
    controls.update()

    // Render

    renderer.render(scene, camera)

    
    // Call tick again on the next frame
    window.requestAnimationFrame(tick)

    //statsend
    // stats.end()
}

tick() 



  
/**
 * webgpu检测方案一
 */
// console.log(navigator.gpu);
// var renderer;
// if (navigator.gpu) {
//   import('three/examples/jsm/renderers/webgpu/WebGPURenderer.js')
//     .then(({ default: WebGPURenderer }) => {
//       renderer = new WebGPURenderer({ canvas: canvas, antialias: true });
//       // Initialize your scene with the WebGPURenderer here
//       renderer.outputColorSpace = 'srgb'
//       renderer.setSize(sizes.width, sizes.height)
//       renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
//       renderer.setClearColor('#333333')
//       const clock = new THREE.Clock()

// const tick = () =>
// {
//     const elapsedTime = clock.getElapsedTime()

//     //statsbegin
//     // stats.begin()

//     // Update materials
//     // portalLightMaterial.uniforms.uTime.value = elapsedTime

//     //update tween
//     TWEEN.update()
    

//     // Update controls
//     controls.update()

//     // Render

//     renderer.render(scene, camera)

    
//     // Call tick again on the next frame
//     window.requestAnimationFrame(tick)

//     //statsend
//     // stats.end()
// }

// tick()
//     })
//     .catch((error) => {
//       console.error('Failed to load WebGPURenderer:', error);
//       // Fallback to WebGLRenderer if you wish or show an error message
      
//     });
// } else if (window.WebGLRenderingContext) {
//   renderer = new THREE.WebGLRenderer({ canvas: canvas, antialias: true });
//   // Initialize your scene with the WebGLRenderer here
//   renderer.outputColorSpace = 'srgb'
//   renderer.setSize(sizes.width, sizes.height)
//   renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
//   renderer.setClearColor('#333333')
//   const clock = new THREE.Clock()

// const tick = () =>
// {
//     const elapsedTime = clock.getElapsedTime()

//     //statsbegin
//     // stats.begin()

//     // Update materials
//     // portalLightMaterial.uniforms.uTime.value = elapsedTime

//     //update tween
//     TWEEN.update()
    

//     // Update controls
//     controls.update()

//     // Render

//     renderer.render(scene, camera)

    
//     // Call tick again on the next frame
//     window.requestAnimationFrame(tick)

//     //statsend
//     // stats.end()
// }

// tick()
// } else {
//   throw new Error("Your browser does not support WebGL or WebGPU");
// }
//     //     renderer.outputColorSpace = 'srgb'
//     //   renderer.setSize(sizes.width, sizes.height)
//     //   renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
//     //   renderer.setClearColor('#333333')

/**
 * webgpu检测方案二
 */

// let renderer;

// const rendererPromise = new Promise((resolve, reject) => {
//   if ( navigator.gpu ) {
//     resolve(
//       import('three/examples/jsm/renderers/webgpu/WebGPURenderer.js')
//       .then(({default: WebGPURenderer}) => {
//         return new WebGPURenderer({ canvas: canvas, antialias: true });
//       })
//     );
//   } else {
//     resolve(new THREE.WebGLRenderer({ canvas: canvas, antialias: true }));
//   }
// });



// // wait for renderer to become available
// rendererPromise
//   .then((resolvedRenderer) => {
//     init(resolvedRenderer);
//   })
//   .catch((error) => {
//     console.error("rendererPromise 解决失败：", error);
//   });

// function init (resolvedRenderer) {
//     renderer = resolvedRenderer
//   // ... rest of your script
//     renderer.outputColorSpace = 'srgb'
//     renderer.setSize(sizes.width, sizes.height)
//     renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
//     renderer.setClearColor('#333333')
//     const clock = new THREE.Clock()

// const tick = () =>
// {
//     const elapsedTime = clock.getElapsedTime()

//     //statsbegin
    
//     stats.begin()

    

//     //update tween
//     TWEEN.update()
    
//     // //箱子跳动
//     // analyser.getByteFrequencyData(dataArray)

//     // updateSmoothedDataArray();
    
    
//     // // 根据音频数据更新箱子的位置和高度
//     // boxes.forEach(box => {
//     //   const frequencyIndex = box.userData.frequencyIndex;
//     //   if (frequencyIndex !== undefined && frequencyIndex < smoothedDataArray.length) {
//     //     const frequencyData = smoothedDataArray[frequencyIndex];
        
//     //     // 打印出来以便调试
//     //     console.log('Frequency data: ', frequencyData);
      
//     //     if (box.material.color.getHexString() === '000000') {
//     //         // 黑色箱子
//     //         box.scale.y = frequencyData / 128 * 4 + 0.12 + box.userData.randomValue ;
//     //     } else if (box.material.color.getHexString() === '202020') {
//     //         // 灰色箱子
//     //         box.scale.y = frequencyData / 128 * 4 + 0.1 + box.userData.randomValue;
//     //     } else if (box.material.color.getHexString() === 'ffffff') {
//     //         // 白色箱子
//     //         box.scale.y = frequencyData / 128 * 4 + 0.09 + box.userData.randomValue ;
//     //     } else {
//     //       console.error('Invalid frequency index: ', frequencyIndex);
//     //     }
//     // }
//     // });

      

    

      

//     // Update controls
//     controls.update()

//     // Render

//     renderer.render(scene, camera)

    
//     // Call tick again on the next frame
//     window.requestAnimationFrame(tick)

//     //statsend
//     stats.end()
// }

// tick()
// }



